// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"57f44777","376":"d2a1d47d","622":"e176b5fa","896":"f5599534"}[chunkId] + ".chunk.css";
};